import React, { useState } from 'react'
import Header from '../main/Header'
import Footer from '../main/Footer'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
export default function Home() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
    };
    const [activeTab, setActiveTab] = useState("web-development");

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    return (
        <>
            <Header />
            <div id="main-wrapper">
                {/* ============================ Hero Banner  Start================================== */}
                <div
                    className="image-cover hero_banner hero-inner-2 shadow rlt">
                    {/* <img src="assets/img/ncc_banner2.jpg" alt="" width={'100%'} /> */}
                    <Carousel>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src="assets/img/ncc_banner2.jpg" // Replace with your image path
                                alt="First slide"
                            />
                            {/* <Carousel.Caption>
                                <h3>First slide</h3>
                                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                            </Carousel.Caption> */}
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src="assets/images/b2.jpg" // Replace with your image path
                                alt="Second slide"
                            />
                            {/* <Carousel.Caption>
                                <h3>Second slide</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </Carousel.Caption> */}
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src="assets/images/b1.jpg" // Replace with your image path
                                alt="Third slide"
                            />
                            <Carousel.Caption>
                                {/* <h3>Third slide</h3>
                                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> */}
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>
                </div>
                {/* ============================ Hero Banner End ================================== */}
                {/* ============================ Trips Facts Start ================================== */}
                {/* <section className="p-0 trips_top">
                    <div className="container">
                        <div className="trip_wrap">
                            <div className="row m-0">
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="trips card">
                                        <div className="trips_icons">
                                            <i className="ti-video-camera" />
                                        </div>
                                        <div className="trips_detail">
                                            <h4>100,000 online courses</h4>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="trips card">
                                        <div className="trips_icons">
                                            <i className="ti-medall" />
                                        </div>
                                        <div className="trips_detail">
                                            <h4>Expert instruction</h4>
                                            <p>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="trips card none">
                                        <div className="trips_icons">
                                            <i className="ti-infinite" />
                                        </div>
                                        <div className="trips_detail">
                                            <h4>Lifetime access</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* ============================ Trips Facts Start ================================== */}
                {/* FAct About */}
                <section>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="about-short">
                                    <div className="sec-heading mb-3">
                                        <h2>
                                            Know about <span className="theme-cl">e-Learn</span> learning
                                            platform
                                        </h2>
                                    </div>
                                    <p>
                                        At National Computer Classes, we offer a diverse range of courses to empower you with essential skills for the digital age. Our <strong>Web Design & Development</strong> program teaches you to create stunning, modern websites using the latest technologies, keeping you ahead in the ever-evolving digital landscape. With our <strong>App Design & Development course</strong>, you'll master the art of building functional, user-friendly mobile applications for both Android and iOS platforms. In <strong>Graphic Design</strong>, unleash your creativity and craft visually compelling designs using industry-standard tools.
                                    </p>
                                    <p>
                                        Our <strong>Accounting & Tally course</strong> equips you with proficiency in financial management and accounting software, providing essential business skills for a successful career. Join us to transform your passion into expertise and stay ahead in the competitive world.
                                    </p>
                                    {/* <div className="cource_facts">
                                        <ul>
                                            <li>
                                                <span className="theme-cl">7m</span>Active Cources
                                            </li>
                                            <li>
                                                <span className="theme-cl">77k</span>Student Learning
                                            </li>
                                            <li>
                                                <span className="theme-cl">84+</span>Free Cources
                                            </li>
                                        </ul>
                                    </div> */}
                                    <a href="##" className="btn btn-modern mt-4">
                                        Know More
                                        <span>
                                            <i className="ti-arrow-right" />
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="list_facts_wrap_img">
                                    <img src="assets/img/edu_2.png" className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* mission and vision */}
                <div className="mission-vision-container">
                    <div className="sec-heading center">
                        <p>Our &amp; Goals</p>
                        <h2>
                            <span className="theme-cl">National</span> Vision & Mission
                        </h2>
                    </div>
                    <div className="row">
                        {/* Unified Card for Mission */}
                        <div className="col-md-6 mb-4">
                            <div className="mission-vision-card">
                                <div className="mission-vision-content">
                                    <h3 className="mission-vision-title">Our Mission</h3>
                                    <p className="mission-vision-description">
                                        At National Computer Classes, our mission is to empower individuals with the
                                        skills needed to thrive in the digital age. We aim to provide high-quality
                                        training in web design, web development, app development, and accounting, helping
                                        students achieve their career goals.
                                    </p>
                                </div>
                                <div className="mission-vision-image">
                                    <img
                                        src="assets/images/mission.jpg"
                                        alt="Mission"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Unified Card for Vision */}
                        <div className="col-md-6 mb-4">
                            <div className="mission-vision-card">
                                <div className="mission-vision-content">
                                    <h3 className="mission-vision-title">Our Vision</h3>
                                    <p className="mission-vision-description">
                                        Our vision is to become a leading educational institution that fosters digital literacy
                                        and innovation. We envision a world where everyone has the skills to succeed in a
                                        technology-driven future, and we are dedicated to shaping the next generation of
                                        professionals in the tech industry.
                                    </p>
                                </div>
                                <div className="mission-vision-image">
                                    <img
                                        src="assets/images/vision.jpg"
                                        alt="Vision"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* mission and vision // */}
                {/* FAct About // */}
                <section class="courses-section">
                    <div className="sec-heading center">
                        <p>Join  &amp; Benifits</p>
                        <h2>
                            <span className="theme-cl">Our Course</span> for Learning
                        </h2>
                    </div>
                    <div class="container">
                        <div className="row">
                            <div className="col-md-4">
                                {/* Web Design Card  */}
                                <div class="course-card">
                                    <div class="course-image">
                                        <img src="assets/images/web-design.png" alt="Web Design" />
                                    </div>
                                    <div class="course-info">
                                        <h4>Web Design</h4>
                                        <p>Create stunning and responsive websites.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                {/* Web Development Card  */}
                                <div class="course-card">
                                    <div class="course-image">
                                        <img src="assets/images/web-development.jpg" alt="Web Development" />
                                    </div>
                                    <div class="course-info">
                                        <h4>Web Development</h4>
                                        <p>Build interactive and dynamic websites.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                {/* App Design Card  */}
                                <div class="course-card">
                                    <div class="course-image">
                                        <img src="assets/images/app-design.png" alt="App Design" />
                                    </div>
                                    <div class="course-info">
                                        <h4>App Design</h4>
                                        <p>Design intuitive and user-friendly apps.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-4 mb">
                                {/* App Development Card  */}
                                <div class="course-card">
                                    <div class="course-image">
                                        <img src="assets/images/app-development.jpg" alt="App Development" />
                                    </div>
                                    <div class="course-info">
                                        <h4>App Development</h4>
                                        <p>Mobile applications for iOS and Android.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                {/* Graphic Design Card  */}
                                <div class="course-card">
                                    <div class="course-image">
                                        <img src="assets/images/graphic-design.jpg" alt="Graphic Design" />
                                    </div>
                                    <div class="course-info">
                                        <h4>Graphic Design</h4>
                                        <p>Design beautiful visuals and graphics.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                {/* Tally & Accounting Card  */}
                                <div class="course-card">
                                    <div class="course-image">
                                        <img src="assets/images/tally.jpg" alt="Tally & Accounting" />
                                    </div>
                                    <div class="course-info">
                                        <h4>Tally & Accounting</h4>
                                        <p>Master accounting with Tally software.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* work & Process */}
                <section>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-5 col-md-6 col-sm-12">
                                <div className="sec-heading center">
                                    <p>Our Process</p>
                                    <h2>
                                        <span className="theme-cl">Working Process</span> to Join National Computer Classes and
                                        Enjoy Benefits
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/* Step 1: Find Course */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="_wrk_prc_wrap">
                                    <div className="_wrk_prc_thumb">
                                        <img src="assets/img/search.png" className="img-fluid" alt="Find Course" />
                                    </div>
                                    <div className="_wrk_prc_caption">
                                        <h4>Choose Your Course</h4>
                                        <p>
                                            Explore a wide range of courses in Web Design, Development, Graphic Design, and more.
                                            Pick the course that fits your interests and career goals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* Step 2: Book Your Seat */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="_wrk_prc_wrap active">
                                    <div className="_wrk_prc_thumb">
                                        <img src="assets/img/schedule.png" className="img-fluid" alt="Book Your Seat" />
                                    </div>
                                    <div className="_wrk_prc_caption">
                                        <h4>Book Your Seat</h4>
                                        <p>
                                            Reserve your spot for the selected course. We offer flexible schedules to fit your needs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* Step 3: Get Certified */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <div className="_wrk_prc_wrap">
                                    <div className="_wrk_prc_thumb">
                                        <img src="assets/img/medal.png" className="img-fluid" alt="Get Certified" />
                                    </div>
                                    <div className="_wrk_prc_caption">
                                        <h4>Earn Your Certificate</h4>
                                        <p>
                                            Upon completion, receive a certification that helps you showcase your skills and advance your career.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* work & Process // */}

                {/* ==========================  Why choice Section =============================== */}
                <div className="why-choose-us-container text-center py-5">
                    <div className="sec-heading center">
                        <p>Why Choose</p>
                        <h2>
                            Why  <span className="theme-cl">Choose</span> Us?
                        </h2>
                    </div>
                    <div className="row justify-content-center">
                        {/* Card 1: Experienced Faculty */}
                        <div className="col-md-4 mb-4">
                            <div className="why-choose-card">
                                <div className="card-body">
                                    <i className="fa fa-graduation-cap icon"></i>
                                    <h4 className="card-title">Experienced Faculty</h4>
                                    <p className="card-text">
                                        Our experienced trainers provide the best guidance, ensuring a rich learning experience for students.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 2: Industry-Relevant Courses */}
                        <div className="col-md-4 mb-4">
                            <div className="why-choose-card">
                                <div className="card-body">
                                    <i className="fa fa-cogs icon"></i>
                                    <h4 className="card-title">Industry-Relevant Courses</h4>
                                    <p className="card-text">
                                        We offer courses designed to meet current industry demands, ensuring our students are job-ready.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Card 3: Hands-on Training */}
                        <div className="col-md-4 mb-4">
                            <div className="why-choose-card">
                                <div className="card-body">
                                    <i className="fa fa-laptop-code icon"></i>
                                    <h4 className="card-title">Hands-on Training</h4>
                                    <p className="card-text">
                                        Our courses focus on practical learning, giving students real-world experience through <br /> projects.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ========================== why choice Section =============================== */}
                {/* Review Section */}
                <section>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-5 col-md-6 col-sm-12">
                                <div className="sec-heading center">
                                    <p>What Our Students Say?</p>
                                    <h2>
                                        <span className="theme-cl">Reviews</span> from Our Successful Students
                                    </h2>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <Slider {...settings}>
                                    <div>
                                        <div
                                            className="testimonial-wraps slick-slide slick-cloned"
                                            data-slick-index={-3}
                                            aria-hidden="true"
                                            tabIndex={-1}
                                            style={{ width: 360 }}
                                        >
                                            <div className="testimonial-icon">
                                                <div className="testimonial-icon-thumb">
                                                    <span className="quotes">
                                                        <i className="fas fa-quote-left" />
                                                    </span>
                                                    <img
                                                        src="assets/img/user-5.jpg"
                                                        className="img-fluid"
                                                        alt="Student Image"
                                                    />
                                                </div>
                                                <h5>Ravi Kumar</h5>
                                                <span>Web Development Student</span>
                                                <div className="testi-rate">
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                </div>
                                            </div>
                                            <div className="facts-detail">
                                                <p>
                                                    "National Computer Classes helped me enhance my skills in web development.
                                                    The faculty is excellent, and the course materials are very thorough. Highly
                                                    recommended!"
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            className="testimonial-wraps slick-slide slick-cloned"
                                            data-slick-index={-3}
                                            aria-hidden="true"
                                            tabIndex={-1}
                                            style={{ width: 360 }}
                                        >
                                            <div className="testimonial-icon">
                                                <div className="testimonial-icon-thumb">
                                                    <span className="quotes">
                                                        <i className="fas fa-quote-left" />
                                                    </span>
                                                    <img
                                                        src="assets/img/user-6.jpg"
                                                        className="img-fluid"
                                                        alt="Student Image"
                                                    />
                                                </div>
                                                <h5>Priya Sharma</h5>
                                                <span>Graphic Design Student</span>
                                                <div className="testi-rate">
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                </div>
                                            </div>
                                            <div className="facts-detail">
                                                <p>
                                                    "The graphic design course at NCC helped me build a strong portfolio.
                                                    The hands-on experience and industry-standard tools made the learning
                                                    process smooth and enjoyable."
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            className="testimonial-wraps slick-slide slick-cloned"
                                            data-slick-index={-3}
                                            aria-hidden="true"
                                            tabIndex={-1}
                                            style={{ width: 360 }}
                                        >
                                            <div className="testimonial-icon">
                                                <div className="testimonial-icon-thumb">
                                                    <span className="quotes">
                                                        <i className="fas fa-quote-left" />
                                                    </span>
                                                    <img
                                                        src="assets/img/user-7.jpg"
                                                        className="img-fluid"
                                                        alt="Student Image"
                                                    />
                                                </div>
                                                <h5>Arvind Singh</h5>
                                                <span>Web Design Student</span>
                                                <div className="testi-rate">
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                </div>
                                            </div>
                                            <div className="facts-detail">
                                                <p>
                                                    "The web design course at National Computer Classes helped me
                                                    improve my skills. The trainers were very helpful and the overall
                                                    experience was amazing!"
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            className="testimonial-wraps slick-slide slick-cloned"
                                            data-slick-index={-2}
                                            aria-hidden="true"
                                            tabIndex={-1}
                                            style={{ width: 360 }}
                                        >
                                            <div className="testimonial-icon">
                                                <div className="testimonial-icon-thumb">
                                                    <span className="quotes">
                                                        <i className="fas fa-quote-left" />
                                                    </span>
                                                    <img
                                                        src="assets/img/user-8.jpg"
                                                        className="img-fluid"
                                                        alt="Student Image"
                                                    />
                                                </div>
                                                <h5>Neha Rathi</h5>
                                                <span>App Design Student</span>
                                                <div className="testi-rate">
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                    <i className="fa fa-star filled" />
                                                </div>
                                            </div>
                                            <div className="facts-detail">
                                                <p>
                                                    "The app design course was great! It provided me with a solid foundation
                                                    to start building apps, and the course was well structured and engaging."
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Review Section // */}
                {/* ============================ technologies ================================== */}
                <section className="technologies-section py-5">
                    <div className="container">
                        <div className="sec-heading center">
                            <p>Technologies</p>
                            <h2>
                                <span className="theme-cl">Technologies</span> We Use
                            </h2>
                        </div>
                        <div className="tech-scroll-wrapper">
                            <marquee behavior="" direction="">
                                <div className="tech-scroll">
                                    {/* Web Development Technologies */}
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>HTML5</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>CSS3</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>JavaScript</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>React</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Node.js</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>PHP</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Bootstrap</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Angular</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>LARAVEL</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>FLUTTER</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>REACT Native</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Adobe Photoshop</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Adobe CorelDraw</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Adobe Illustrator</h5>
                                        </div>
                                    </div>
                                    <div className="tech-card">
                                        <div className="tech-card-body">
                                            <h5>Tally & Accounting</h5>
                                        </div>
                                    </div>
                                </div>
                            </marquee>
                        </div>
                    </div>
                </section>

                {/* ============================ technologies ================================== */}
                {/* Team Section */}
                <section className="team-section py-5">
                    <div className="container">
                        <div className="sec-heading center">
                            <p>Our Team</p>
                            <h2>Meet Our
                                <span className="theme-cl"> Expert </span> Team
                            </h2>
                        </div>
                        <h2 className="section-title text-center mb-4"></h2>
                        <p className="section-description text-center mb-5">
                            At National Computer Classes, our team is the foundation of our success. With years of experience and a passion for teaching, they are committed to shaping the future of coding education.
                        </p>

                        <div className="row justify-content-center">
                            {/* Team Member 1 */}
                            <div className="col-md-3 col-6 mb-4">
                                <div className="card shadow team-card">
                                    <img src="assets/images/t.jpg" alt="Vishal Kumawat" className="card-img-top rounded-circle mx-auto mt-3 team-image" />
                                    <div className="card-body text-center">
                                        <h5 className="card-title">Mohan Kumawat</h5>
                                        <p className="card-text text-muted">Founder & Lead Instructor</p>
                                        <div className="social-icons">
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-facebook" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-twitter" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-instagram" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Team Member 2 */}
                            <div className="col-md-3  col-6 mb-4">
                                <div className="card shadow team-card">
                                    <img src="assets/images/t.jpg" alt="Aarti Sharma" className="card-img-top rounded-circle mx-auto mt-3 team-image" />
                                    <div className="card-body text-center">
                                        <h5 className="card-title">Radhika Kumawat</h5>
                                        <p className="card-text text-muted">Senior Web Development</p>
                                        <div className="social-icons">
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-facebook" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-twitter" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-instagram" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Team Member 3 */}
                            <div className="col-md-3  col-6 mb-4">
                                <div className="card shadow team-card">
                                    <img src="assets/images/t.jpg" alt="Rajesh Verma" className="card-img-top rounded-circle mx-auto mt-3 team-image" />
                                    <div className="card-body text-center">
                                        <h5 className="card-title">Bhumika </h5>
                                        <p className="card-text text-muted">App Development Guru</p>
                                        <div className="social-icons">
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-facebook" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-twitter" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-instagram" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Team Member 4 */}
                            <div className="col-md-3  col-6 mb-4">
                                <div className="card shadow team-card">
                                    <img src="assets/images/t.jpg" alt="Rajesh Verma" className="card-img-top rounded-circle mx-auto mt-3 team-image" />
                                    <div className="card-body text-center">
                                        <h5 className="card-title">Ankit Verma</h5>
                                        <p className="card-text text-muted">App Development Guru</p>
                                        <div className="social-icons">
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-facebook" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-twitter" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-linkedin" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                                                <i className="fa fa-instagram" aria-hidden="true"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Team Section // */}
                {/* ============================== Start Newsletter ================================== */}
                <section
                    className="bg-cover newsletter inverse-theme"
                    style={{ background: "url(assets/img/banner-2.jpg)" }}
                    data-overlay={9}
                >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-7 col-md-8 col-sm-12">
                                <div className="text-center">
                                    <h2>Join Thousand of Happy Students!</h2>
                                    <p>Subscribe our newsletter &amp; get latest news and updation!</p>
                                    <form className="sup-form">
                                        <input
                                            type="email"
                                            className="form-control sigmup-me"
                                            placeholder="Your Email Address"
                                            required="required"
                                        />
                                        <input
                                            type="submit"
                                            className="btn btn-theme"
                                            defaultValue="Get Started"
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* ================================= End Newsletter =============================== */}
            </div>
            <Footer />
        </>

    )
}
